import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from 'vuex';
import { stepForm } from '~/mixins';
import posNormal from '~~/jsons/pos.json';
import posVirtual from '~~/jsons/virtual.json';
import loader from '../modals/loader';

export default {
    mixins: [stepForm],
    components: {
        loader: loader
    },
    data: function data() {
        var products = this.$store.state['master-data'].products;

        return {
            products: products,
            productsIcons: {
                presential: [{ id: 1, title: 'Poket', subtitle: 'Ideal cuando tienes internet por cable.', icon: 'icon-ic-conect-red' }, { id: 2, title: 'Full', subtitle: 'Ideal cuando tienes internet por cable.', icon: 'icon-ic-conect-red' }, { id: 3, title: 'Poket Pro', subtitle: 'Ideal para aceptar pagos con todas las tarjetas.', icon: 'icon-ic-conect-red' }, { id: 4, title: 'POS Fijo Internet', subtitle: 'Ideal cuando tienes internet por cable.', icon: 'icon-ic-conect-red' },
                // { id: 5, title: 'POS Fijo telefónico', subtitle: 'Ideal si no tienes internet pero sí línea telefónica Movistar.', icon:'icon-ic-conect-telf' },
                { id: 5, title: 'POS Inalámbrico', subtitle: 'Ideal para aceptar pagos en cualquier parte de tu local y delivery.', icon: 'icon-ic-delivery' },
                // { id: 7, title: 'Poket POS', subtitle: 'Ideal para llevarlo contigo y aceptar pagos donde estés.', icon:'icon-group-2' },
                { id: 6, title: 'Corresponsalía', subtitle: 'Ideal para funcionamiento de agentes bancarios.', icon: 'icon-ic-conect-red' }],
                virtual: [{ id: 1, title: 'Pago Web', subtitle: 'Formulario de pago amigable, <br> bilingüe y se acomoda a la pantalla.', icon: 'icon-ic-carrito' }, { id: 2, title: 'Pago Link', subtitle: 'Ideal si ofreces pocos servicios o si son personalizados.', icon: 'icon-ic-internet' }, { id: 3, title: 'Pago App', subtitle: 'Formulario especial para apps.', icon: 'icon-ic-app' }, { id: 4, title: 'Tuvitrina.com', subtitle: 'Creamos la página web por ti.', icon: 'icon-internet' }]
            },
            selectedIndex: null,
            posNormal: posNormal,
            posVirtual: posVirtual
        };
    },

    computed: {
        selectedProduct: function selectedProduct() {
            return this.products[this.selectedIndex] || null;
        },
        productType: function productType() {
            if ([0, 1, 2, 3, 4, 5].indexOf(this.selectedIndex) > -1) return '1'; //Productos POS [3 pos fijo][4 pos inalambrico]
            if ([6, 7, 8, 9].indexOf(this.selectedIndex) > -1) return '2'; // Productos virtuales
            return null;
        },
        jsonData: function jsonData() {
            switch (this.productType) {
                case '1':
                    return this.posNormal;
                case '2':
                    return this.posVirtual;
                default:
                    return null;
            }
        },
        selectedJsonData: function selectedJsonData() {
            if (this.productType === '1') {
                return this.jsonData && this.selectedIndex !== null ? this.jsonData[this.selectedIndex + 1] : null;
            } else {
                return this.jsonData && this.selectedIndex !== null ? this.jsonData[this.selectedIndex] : null;
            }
        }
    },
    methods: {
        saveSolution: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.prev = 0;

                                                    if (!(!this.selectedProduct || !this.selectedJsonData)) {
                                                        _context.next = 3;
                                                        break;
                                                    }

                                                    throw new Error('Por favor vuelva a seleccionar el producto');

                                                case 3:
                                                    _context.t0 = this.selectedProduct.Name;
                                                    _context.next = _context.t0 === 'Poket' ? 6 : _context.t0 === 'Full' ? 6 : _context.t0 === 'Poket Pro' ? 6 : _context.t0 === 'Poket POS' ? 7 : _context.t0 === 'Tuvitrina.com' ? 8 : 9;
                                                    break;

                                                case 6:
                                                    return _context.abrupt('return', location.href = 'https://dashboard.vendemas.com.pe/register/');

                                                case 7:
                                                    return _context.abrupt('return', location.href = 'https://www.visanet.com.pe/poketpos/');

                                                case 8:
                                                    return _context.abrupt('return', location.href = 'https://www.tuvitrina.com');

                                                case 9:
                                                    console.log("selectedProduct", _JSON$stringify(this.selectedProduct));
                                                    console.log("productType", this.productType);
                                                    console.log("selectedJsonData", this.selectedJsonData);
                                                    _context.next = 14;
                                                    return this.$store.dispatch("affiliations/form/saveProductChoice", {
                                                        productId: this.selectedProduct.IdProduct,
                                                        productType: this.productType,
                                                        pos: this.selectedJsonData
                                                    });

                                                case 14:
                                                    this.$store.commit('affiliations/form/setShowSteppeds', true);

                                                case 15:
                                                    _context.next = 20;
                                                    break;

                                                case 17:
                                                    _context.prev = 17;
                                                    _context.t1 = _context['catch'](0);

                                                    this.$controlMessage(_context.t1);

                                                case 20:
                                                    this.$refs.loaderModal.closeLoader();

                                                case 21:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, this, [[0, 17]]);
                                })));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function saveSolution() {
                return _ref.apply(this, arguments);
            }

            return saveSolution;
        }()
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/product-choice.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/product-choice.vue
// module chunks = 0 1 2 3